import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {baseUrl} from "../../../../core/constants/base-url";
import {resources} from "../../../../core/models/resource/resources";

@Injectable({
  providedIn: 'root'
})
export class DesignBlocksApiService {
  private http: HttpClient = inject(HttpClient);

  public initializeDesignBlocks(productCardId: number): Observable<void> {
    const params = { productCardId: productCardId.toString() };

    return this.http.post<void>(`${baseUrl}/${resources['design-blocks'].path}/initialize`, {}, {
      params: params
    });
  }
}
